import { Navigate } from "react-router-dom";
import React, { useEffect, Fragment } from "react";

import { useRecoilValue } from "recoil";
import { authAtom } from "../../shared/auth";
import { getUserRoll } from "../../helper/getUserRoll";
import NotAuthorized from "../../core/components/NotAuthorized/NotAuthorized";

import { RouteMode } from "../../constant/enum/RouteAccessLevel";
import { RollAccessLevel } from "../../constant/enum/RouteAccessLevel";

// ______**** check Roll User and abillty user for show Coomponent and navbar  ****__________

// ___________________ALIREZA RAHIMI __________________
// ___________________ALIREZA RAHIMI __________________
// ___________________ALIREZA RAHIMI __________________

// this a parent layer component that controll roll access level

const ProtectedRoute = ({ children, layoutMode }) => {
  const user = useRecoilValue(authAtom);
  let AccesiblityRoute = getUserRoll();

  const isAccessRoute = () => {
    const RouteAccessList = RollAccessLevel[layoutMode];
    let isAccess = false;

    for (let i = 0; i < AccesiblityRoute.length; i++) {
      const isExist = RouteAccessList.includes(AccesiblityRoute[i]);
      if (isExist) {
        isAccess = true;
        break;
      }
    }
    return isAccess;
  };

  useEffect(() => {
    if (!user) {
      Navigate.push("/dashboard");
    }
  }, []);

  return <>{user ? isAccessRoute() ? children : <NotAuthorized /> : null}</>;
};

export default ProtectedRoute;

// ___________________ALIREZA RAHIMI __________________
// ___________________ALIREZA RAHIMI __________________
// ___________________ALIREZA RAHIMI __________________
